// extracted by mini-css-extract-plugin
export default {"slotAppShell":"PlasmicAppShell_slotAppShell__XmFYR","slotAppShelllayoutType__default":"PlasmicAppShell_slotAppShelllayoutType__default__dN0sC"};